var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconClearfilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 17.448,
    viewBox: "0 0 19 17.448",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon_clearfilter",
    d: "M5.273,8.164,0,3.945V3.164H14.836v.781L9.562,8.164v4.213L5.273,15.891Zm5.344,2.911a3.691,3.691,0,1,1,3.691,3.691A3.7,3.7,0,0,1,10.617,11.074Zm4.437,1.491.746-.746-.746-.746.746-.746-.746-.746-.746.746-.746-.746-.746.746.746.746-.746.746.746.746.746-.746ZM0,2.109V0H14.836V2.109Z",
    transform: "translate(0.5 0.5)",
    fill: "white",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClearfilter);
export default __webpack_public_path__ + "static/media/icon_clearfilter.1c6c64bb8154877f6823adc3b99dd0ea.svg";
export { ForwardRef as ReactComponent };